
import prompt from "./prompt.js"
import verify from "./verify.js"

export default {
    ...prompt,
    ...verify
}